export default {
  pickup: 'Ridicare',
  delivery: 'Livrare',
  ongoing_order: 'Comandă în curs',
  view_more: 'Apasă pentru detalii',
  status: {
    rejected: {
      title: 'Comandă respinsă',
      description: 'Apasă pentru detalii',
    },
    created: {
      description: 'Comandă primită',
    },
    reviewed: {
      description: 'Comanda ta a fost vizualizată',
    },
  },
  order_type: {
    pickup: 'ridicare',
    delivery: 'livrare',
  },
  order_status_toast: {
    order_reviewed: '#{{number}} Comanda ta a fost vizualizată',
    order_confirmed: '#{{number}} Timp confirmat {{time}}',
    order_preparation_up_time_changed: '#{{number}} Ora de {{type}} schimbată la {{time}}',
    order_preparing: 'Comanda ta #{{number}} este în pregătire',
    order_rejected: 'Comanda #{{number}} respinsă',
  },
  error_messages: {
    failed_to_load: 'Ceva nu a mers bine, te rugăm să încerci din nou.',
  },
};
